import React, { useState, useEffect, useRef, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useNavigate, useLocation } from "react-router-dom";
import { gsap } from "gsap";
import SocketContext from "../../contexts/SocketContext";

import "./AddProdModal.css";
import SearchField from "../SearchField/SearchField";

const AddProdModal = ({ show, setShow, setReloaddata, reloaddata }) => {
  //Refs
  const NPNmsgRef = useRef();
  const NPGmsgRef = useRef();
  const NPCTmsgRef = useRef();
  const NBUmsgRef = useRef();
  const NIMOmsgRef = useRef();

  // Socket
  const { socket } = useContext(SocketContext);

  //AxiosPrivate and Location
  const axiosPrivate = useAxiosPrivate(null);
  const navigate = useNavigate();
  const location = useLocation();

  //Toggle state to clear SearchFields
  const [toggleClearSF, setToggleClearSF] = useState(false);
  const [toggleClearSFNPM, setToggleClearSFNPM] = useState(false);

  //New Product Data Object
  const [newproduct, setNewproduct] = useState();

  //New PrdName Data Object
  const [newprodname, setNewprodname] = useState();
  const [showAddProdName, setShowAddProdName] = useState(false); //toggle newprodname form show/hide

  //New ProdGroup
  const [newprodgroup, setNewprodgroup] = useState();
  const [showAddProdGroup, setShowAddProdGroup] = useState(false);

  //New ProdCatName
  const [newprodcatname, setNewprodcatname] = useState();
  const [showAddProdCatName, setShowAddProdCatName] = useState(false);

  //New BUnit
  const [newbunit, setNewbunit] = useState();
  const [showAddBUnit, setShowAddBUnit] = useState(false);

  //New IMO
  const [newIMO, setNewIMO] = useState();
  const [showAddIMO, setShowAddIMO] = useState(false);

  // Show New ProdName Response Message
  const [NPNmsg, setNPNmsg] = useState();
  const [showNPNmsg, setShowNPNmsg] = useState(false);
  const onNPComplete = () => {
    setNPNmsg(null);
  };
  useEffect(() => {
    const elem = NPNmsgRef.current;
    gsap.fromTo(
      elem,
      { opacity: 1 },
      {
        opacity: 0,
        duration: 2.5,
        ease: "power1.inOut",
        onComplete: onNPComplete,
      }
    );
  }, [showNPNmsg]);
  // Show New ProdGroup Response Message
  const [NPGmsg, setNPGmsg] = useState();
  const [showNPGmsg, setShowNPGmsg] = useState(false);
  const onNPGComplete = () => {
    setNPGmsg(null);
  };
  useEffect(() => {
    const elem = NPGmsgRef.current;
    gsap.fromTo(
      elem,
      { opacity: 1 },
      {
        opacity: 0,
        duration: 2.5,
        ease: "power1.inOut",
        onComplete: onNPGComplete,
      }
    );
  }, [showNPGmsg]);
  // Show New ProdCatName Response Message
  const [NPCTmsg, setNPCTmsg] = useState();
  const [showNPCTmsg, setShowNPCTmsg] = useState(false);
  const onNPCTComplete = () => {
    setNPCTmsg(null);
  };
  useEffect(() => {
    const elem = NPCTmsgRef.current;
    gsap.fromTo(
      elem,
      { opacity: 1 },
      {
        opacity: 0,
        duration: 2.5,
        ease: "power1.inOut",
        onComplete: onNPCTComplete,
      }
    );
  }, [showNPCTmsg]);
  // Show New BUnit Response Message
  const [NBUmsg, setNBUmsg] = useState();
  const [showNBUmsg, setShowNBUmsg] = useState(false);
  const onNBUComplete = () => {
    setNBUmsg(null);
  };
  useEffect(() => {
    const elem = NBUmsgRef.current;
    gsap.fromTo(
      elem,
      { opacity: 1 },
      {
        opacity: 0,
        duration: 2.5,
        ease: "power1.inOut",
        onComplete: onNBUComplete,
      }
    );
  }, [showNBUmsg]);
  // Show New IMO Response Message
  const [NIMOmsg, setNIMOmsg] = useState();
  const [showNIMOmsg, setShowNIMOmsg] = useState(false);
  const onNIMOComplete = () => {
    setNIMOmsg(null);
  };
  useEffect(() => {
    const elem = NIMOmsgRef.current;
    gsap.fromTo(
      elem,
      { opacity: 1 },
      {
        opacity: 0,
        duration: 2.5,
        ease: "power1.inOut",
        onComplete: onNIMOComplete,
      }
    );
  }, [showNIMOmsg]);

  // Handle Select Prod Name
  const handleSelectProdName = (item) => {
    setNewproduct({
      ...newproduct,
      ["productName"]: item.prodNameID,
      ["prodName"]: item.prodName,
    });
  };

  // Handle Select Supplier
  const handleSelectSupplier = (item) => {
    setNewproduct({
      ...newproduct,
      ["supplierID"]: item.supplierID,
      ["companyCode"]: item.companyCode,
    });
  };

  // Handle Select Prodgroup
  const handleSelectProdGroup = (item) => {
    setNewprodname({
      ...newprodname,
      ["prodGroupID"]: item.prodGroupID,
      ["productGroup"]: item.productGroup,
    });
  };
  // Handle Select ProdCatName
  const handleSelectProdCatName = (item) => {
    setNewprodname({
      ...newprodname,
      ["prodCatNameID"]: item.prodCatNameID,
      ["prodCatName"]: item.prodCatName,
    });
  };
  // Handle Select B Unit
  const handleSelectBUnit = (item) => {
    setNewprodname({
      ...newprodname,
      ["BUID"]: item.BUID,
      ["businessUnit"]: item.businessUnit,
    });
  };
  // Handle Select IMO
  const handleSelectIMO = (item) => {
    setNewprodname({
      ...newprodname,
      ["IMOID"]: item.IMOID,
      ["IMO"]: item.IMO,
    });
  };
  // Handle Input Change
  const handleInputChange = (e) => {
    setNewprodname({ ...newprodname, [e.target.name]: e.target.value });
  };

  // Save New Product function
  const saveNewProduct = async () => {
    try {
      const response = await axiosPrivate.post("/api/products/savenewproduct", {
        newproduct,
      });
      if (response.data.msg === "Saved") {
        setShow(false);
        setReloaddata(!reloaddata);
        APMCleanup();
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };
  // Save New ProdName function
  const saveNewProdName = async () => {
    try {
      const response = await axiosPrivate.post("/api/products/savenewprodname", {
        newprodname,
      });
      if (response.data.msg) {
        setNPNmsg(response.data.msg);
        setShowNPNmsg(!showNPNmsg);
      }
      if (response.data.msg === "Saved") {
        NPNCancel();
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };
  // Save New ProdGroup Function
  const saveNewProdGroup = async () => {
    try {
      const response = await axiosPrivate.post("/api/products/savenewprodgroup", {
        newprodgroup,
      });
      if (response.data.msg) {
        setNPGmsg(response.data.msg);
        setShowNPGmsg(!showNPGmsg);
      }
      if (response.data.msg === "Saved") {
        NPGCancel();
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };
  // Save New ProdCatName Function
  const saveNewProdCatName = async () => {
    try {
      const response = await axiosPrivate.post("/api/products/savenewprodcatname", {
        newprodcatname,
      });
      if (response.data.msg) {
        setNPCTmsg(response.data.msg);
        setShowNPCTmsg(!showNPCTmsg);
      }
      if (response.data.msg === "Saved") {
        NPCTCancel();
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // Save New BUnit Function
  const saveNewBUnit = async () => {
    try {
      const response = await axiosPrivate.post("/api/products/savenewbunit", {
        newbunit,
      });
      if (response.data.msg) {
        setNBUmsg(response.data.msg);
        setShowNBUmsg(!showNBUmsg);
      }
      if (response.data.msg === "Saved") {
        NBUCancel();
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };
  // Save New IMO Function
  const saveNewIMO = async () => {
    try {
      const response = await axiosPrivate.post("/api/products/savenewimo", {
        newIMO,
      });
      if (response.data.msg) {
        setNIMOmsg(response.data.msg);
        setShowNIMOmsg(!showNIMOmsg);
      }
      if (response.data.msg === "Saved") {
        NIMOCancel();
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  // Clean up on modal close
  const APMCleanup = () => {
    setShowAddProdName(false);
    setNewproduct({});
    setToggleClearSF(!toggleClearSF);
    setNewprodname({});
  };

  // Clean up on NPN cancel
  const NPNCancel = () => {
    setNewprodname({});
    setToggleClearSFNPM(!toggleClearSFNPM);
  };
  // Clean up on NPG Cancel
  const NPGCancel = () => {
    setNewprodgroup({});
    setShowAddProdGroup(false);
  };
  // Clean up on NPCT Cancel
  const NPCTCancel = () => {
    setNewprodcatname({});
    setShowAddProdCatName(false);
  };
  // Clean up on NBU Cancel
  const NBUCancel = () => {
    setNewbunit({});
    setShowAddBUnit(false);
  };
  // Clean up on NIMO Cancel
  const NIMOCancel = () => {
    setNewIMO({});
    setShowAddIMO(false);
  };

  return (
    <div className={show ? "custommodal" : "custommodal hide"}>
      <div className='modal-main'>
        <div className='addproduct'>
          <div className='ap-header'>
            <h2>Add New Product:</h2>
            <p
              onClick={(e) => {
                setShow(false);
                APMCleanup();
              }}
            >
              Close
            </p>
          </div>
          <form
            className='add-products-form'
            onSubmit={(e) => {
              e.preventDefault();
              saveNewProduct();
            }}
          >
            <div className='form-item'>
              <label>ProdName:</label>
              <SearchField
                required={true}
                searchURL={"/api/products/getprodnames"}
                value={newproduct?.prodName}
                valueName='prodName'
                onItemSelect={handleSelectProdName}
                style={{ width: 230 }}
                clearfield={toggleClearSF}
              />
              <div className='ap-icon'>
                <FontAwesomeIcon icon={faPlusSquare} onClick={(e) => setShowAddProdName(true)} />
              </div>
            </div>
            <div className='form-item'>
              <label>Supplier:</label>
              <SearchField
                required={true}
                searchURL={"/api/suppliers"}
                value={newproduct?.companyCode}
                valueName='companyCode'
                onItemSelect={handleSelectSupplier}
                style={{ width: 230 }}
                clearfield={toggleClearSF}
              />
              <div className='ap-icon'></div>
            </div>
            <div className='form-buttons'>
              <button
                type='button'
                onClick={(e) => {
                  APMCleanup();
                }}
              >
                Cancel
              </button>
              <button className='mainbutton' type='submit'>
                Save New Product
              </button>
            </div>
          </form>
        </div>
        {showAddProdName && (
          <div className='APsubforms'>
            <div className='addprodname'>
              <h2>Add New ProdName:</h2>
              <form
                className='add-prodname-form'
                onSubmit={(e) => {
                  e.preventDefault();
                  saveNewProdName();
                }}
              >
                <div className='form-item'>
                  <label>ProdGroup:</label>
                  <SearchField
                    required={true}
                    searchURL='/api/products/getprodgroups'
                    value={newprodname?.productGroup}
                    valueName='productGroup'
                    valueID='prodGroupID'
                    style={{ width: "180px" }}
                    onItemSelect={handleSelectProdGroup}
                    clearfield={toggleClearSFNPM}
                  />
                  <div className='ap-icon'>
                    <FontAwesomeIcon
                      icon={faPlusSquare}
                      onClick={(e) => {
                        setShowAddProdGroup(true);
                        setShowAddProdCatName(false);
                        setShowAddBUnit(false);
                        setShowAddIMO(false);
                      }}
                    />
                  </div>
                </div>

                <div className='form-item'>
                  <label>ProdCatName:</label>
                  <SearchField
                    required={true}
                    searchURL='/api/products/getprodcatnames'
                    value={newprodname?.prodCatName}
                    valueName='prodCatName'
                    valueID='prodCatNameID'
                    style={{ width: "180px" }}
                    onItemSelect={handleSelectProdCatName}
                    clearfield={toggleClearSFNPM}
                  />
                  <div className='ap-icon'>
                    <FontAwesomeIcon
                      icon={faPlusSquare}
                      onClick={(e) => {
                        setShowAddProdGroup(false);
                        setShowAddProdCatName(true);
                        setShowAddBUnit(false);
                        setShowAddIMO(false);
                      }}
                    />
                  </div>
                </div>
                <div className='form-item'>
                  <label>Abbreviation:</label>
                  <input
                    required={true}
                    name='abbreviation'
                    autoComplete='off'
                    style={{ width: "180px" }}
                    type='text'
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    value={newprodname?.abbreviation || ""}
                  />
                  <div className='ap-icon'></div>
                </div>
                <div className='form-item'>
                  <label>ProdName:</label>
                  <input
                    required={true}
                    name='prodName'
                    autoComplete='off'
                    style={{ width: "180px" }}
                    type='text'
                    onChange={(e) => {
                      handleInputChange(e);
                    }}
                    value={newprodname?.prodName || ""}
                  />
                  <div className='ap-icon'></div>
                </div>
                <div className='form-item'>
                  <label>BUnit:</label>
                  <SearchField
                    required={true}
                    searchURL='/api/products/getbunits'
                    value={newprodname?.businessUnit}
                    valueName='businessUnit'
                    valueID='BUID'
                    style={{ width: "180px" }}
                    onItemSelect={handleSelectBUnit}
                    clearfield={toggleClearSFNPM}
                  />
                  <div className='ap-icon'>
                    <FontAwesomeIcon
                      icon={faPlusSquare}
                      onClick={(e) => {
                        setShowAddProdGroup(false);
                        setShowAddProdCatName(false);
                        setShowAddBUnit(true);
                        setShowAddIMO(false);
                      }}
                    />
                  </div>
                </div>
                <div className='form-item'>
                  <label>IMO:</label>
                  <SearchField
                    required={true}
                    searchURL='/api/products/getimogroups'
                    value={newprodname?.IMO}
                    valueName='IMO'
                    valueID='IMOID'
                    style={{ width: "180px" }}
                    onItemSelect={handleSelectIMO}
                    clearfield={toggleClearSFNPM}
                  />
                  <div className='ap-icon'>
                    <FontAwesomeIcon
                      icon={faPlusSquare}
                      onClick={(e) => {
                        setShowAddProdGroup(false);
                        setShowAddProdCatName(false);
                        setShowAddBUnit(false);
                        setShowAddIMO(true);
                      }}
                    />
                  </div>
                </div>
                <div style={{ position: "relative", color: "var(--purple)" }} className='form-buttons'>
                  <button
                    type='button'
                    onClick={(e) => {
                      NPNCancel();
                    }}
                  >
                    Cancel
                  </button>
                  <button className='mainbutton' type='submit'>
                    Save New ProdName
                  </button>
                </div>
                <span className='respmsg' ref={NPNmsgRef}>
                  {NPNmsg}
                </span>
              </form>
            </div>
            {showAddProdGroup && (
              <div className='addprodgroup'>
                <h2>Add New ProdGroup:</h2>
                <form
                  className='add-prodgroup-form'
                  onSubmit={(e) => {
                    e.preventDefault();
                    saveNewProdGroup();
                  }}
                >
                  <div className='form-item'>
                    <label>New ProdGroup:</label>
                    <input
                      required={true}
                      name='prodGroup'
                      autoComplete='off'
                      style={{ width: "180px" }}
                      type='text'
                      onChange={(e) => {
                        setNewprodgroup({ [e.target.name]: e.target.value });
                      }}
                      value={newprodgroup?.prodGroup || ""}
                    />
                  </div>
                  <div style={{ position: "relative", color: "var(--purple)" }} className='form-buttons'>
                    <button
                      type='button'
                      onClick={(e) => {
                        NPGCancel();
                      }}
                    >
                      Cancel
                    </button>
                    <button className='mainbutton' type='submit'>
                      Save New ProdGroup
                    </button>
                  </div>
                  <span className='respmsg' ref={NPGmsgRef}>
                    {NPGmsg}
                  </span>
                </form>
              </div>
            )}
            {showAddProdCatName && (
              <div className='addprodgroup'>
                <h2>Add New ProdCatName:</h2>
                <form
                  className='add-prodgroup-form'
                  onSubmit={(e) => {
                    e.preventDefault();
                    saveNewProdCatName();
                  }}
                >
                  <div className='form-item'>
                    <label>New ProdCatName:</label>
                    <input
                      required={true}
                      name='prodCatName'
                      autoComplete='off'
                      style={{ width: "180px" }}
                      type='text'
                      onChange={(e) => {
                        setNewprodcatname({ [e.target.name]: e.target.value });
                      }}
                      value={newprodcatname?.prodCatName || ""}
                    />
                  </div>
                  <div style={{ position: "relative", color: "var(--purple)" }} className='form-buttons'>
                    <button
                      type='button'
                      onClick={(e) => {
                        NPCTCancel();
                      }}
                    >
                      Cancel
                    </button>
                    <button style={{ width: "190px" }} className='mainbutton' type='submit'>
                      Save New ProdCatName
                    </button>
                  </div>
                  <span className='respmsg' ref={NPCTmsgRef}>
                    {NPCTmsg}
                  </span>
                </form>
              </div>
            )}
            {showAddBUnit && (
              <div className='addprodgroup'>
                <h2>Add New BUnit:</h2>
                <form
                  className='add-prodgroup-form'
                  onSubmit={(e) => {
                    e.preventDefault();
                    saveNewBUnit();
                  }}
                >
                  <div className='form-item'>
                    <label>New BUnit:</label>
                    <input
                      required={true}
                      name='businessUnit'
                      autoComplete='off'
                      style={{ width: "180px" }}
                      type='text'
                      onChange={(e) => {
                        setNewbunit({ [e.target.name]: e.target.value });
                      }}
                      value={newbunit?.businessUnit || ""}
                    />
                  </div>
                  <div style={{ position: "relative", color: "var(--purple)" }} className='form-buttons'>
                    <button
                      type='button'
                      onClick={(e) => {
                        NBUCancel();
                      }}
                    >
                      Cancel
                    </button>
                    <button style={{ width: "190px" }} className='mainbutton' type='submit'>
                      Save New BUnit
                    </button>
                  </div>
                  <span className='respmsg' ref={NBUmsgRef}>
                    {NBUmsg}
                  </span>
                </form>
              </div>
            )}
            {showAddIMO && (
              <div className='addprodgroup'>
                <h2>Add New IMO:</h2>
                <form
                  className='add-prodgroup-form'
                  onSubmit={(e) => {
                    e.preventDefault();
                    saveNewIMO();
                  }}
                >
                  <div className='form-item'>
                    <label>New IMO:</label>
                    <input
                      required={true}
                      name='IMO'
                      autoComplete='off'
                      style={{ width: "180px" }}
                      type='text'
                      onChange={(e) => {
                        setNewIMO({
                          ...newIMO,
                          [e.target.name]: e.target.value,
                        });
                      }}
                      value={newIMO?.IMO || ""}
                    />
                  </div>
                  <div className='form-item'>
                    <label>UN/NA:</label>
                    <input
                      required={true}
                      name='UN/NA'
                      autoComplete='off'
                      style={{ width: "180px" }}
                      type='text'
                      onChange={(e) => {
                        setNewIMO({
                          ...newIMO,
                          [e.target.name]: e.target.value,
                        });
                      }}
                      value={newIMO?.["UN/NA"] || ""}
                    />
                  </div>
                  <div className='form-item'>
                    <label>Hazard Class:</label>
                    <input
                      required={true}
                      name='hazardClass'
                      autoComplete='off'
                      style={{ width: "180px" }}
                      type='text'
                      onChange={(e) => {
                        setNewIMO({
                          ...newIMO,
                          [e.target.name]: e.target.value,
                        });
                      }}
                      value={newIMO?.["hazardClass"] || ""}
                    />
                  </div>
                  <div className='form-item'>
                    <label>Packing Group:</label>
                    <input
                      required={true}
                      name='packingGroup'
                      autoComplete='off'
                      style={{ width: "180px" }}
                      type='text'
                      onChange={(e) => {
                        setNewIMO({
                          ...newIMO,
                          [e.target.name]: e.target.value,
                        });
                      }}
                      value={newIMO?.["packingGroup"] || ""}
                    />
                  </div>
                  <div style={{ position: "relative", color: "var(--purple)" }} className='form-buttons'>
                    <button
                      type='button'
                      onClick={(e) => {
                        NIMOCancel();
                      }}
                    >
                      Cancel
                    </button>
                    <button style={{ width: "190px" }} className='mainbutton' type='submit'>
                      Save New IMO
                    </button>
                  </div>
                  <span className='respmsg' ref={NIMOmsgRef}>
                    {NIMOmsg}
                  </span>
                </form>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AddProdModal;
